/*
  cart-upsell.js

  Behaviour for sections/cart-upsell.liquid. Carries no Liquid, so it is a plain
  cacheable asset. Everything it needs comes out of the DOM: per-section config
  and the seeded product feed from the two application/json script tags, and the
  live cart state from the progress region, which is re-rendered server side on
  every cart change.

  Initialises every [data-cart-upsell] root on the page, once each, and re-runs
  on shopify:section:load so the theme editor works.
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.cuInit === '1') return;
    root.dataset.cuInit = '1';


    function readJSON(el) {
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function rootPath() {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return r || '/';
    }

    var cfg = readJSON(root.querySelector('[data-cu-config]')) || {};
    var S = cfg.strings || {};
    var SW = cfg.swatches || {};
    var COLOR_OPTS = (cfg.colorOptions || []).filter(Boolean);

    var trackEl = root.querySelector('[data-cu-track]');
    var panelEl = root.querySelector('[data-cu-panel]');
    var pbodyEl = root.querySelector('[data-cu-pbody]');
    var ptierEl = root.querySelector('[data-cu-ptier]');
    var scrimEl = root.querySelector('[data-cu-scrim]');
    var qaEl = root.querySelector('[data-cu-quickadd]');
    var titleEl = root.querySelector('[data-cu-qa-title]');
    var linkEl = root.querySelector('[data-cu-qa-link]');
    var errEl = root.querySelector('[data-cu-error]');
    var prevBtn = root.querySelector('[data-cu-prev]');
    var nextBtn = root.querySelector('[data-cu-next]');

    var feed = readJSON(root.querySelector('[data-cu-seed]'));
    var cartState = readCartState();
    var byId = {}, shown = [], pool = [], openId = null, sel = {}, busy = false;

    function readCartState() {
      return readJSON(root.querySelector('[data-cu-cart-state]')) ||
        { itemCount: 0, needed: 0, hasNext: false, nextPct: '', nextReward: '', nextRewardShort: '', productIds: [], tags: [] };
    }

    /* --------------------------------------------------------- collection */

    function lastCollection() {
      try {
        var v = JSON.parse(window.localStorage.getItem('ml_last_collection') || 'null');
        if (!v || !v.handle) return null;
        if (v.ts && Date.now() - v.ts > (cfg.memoryHours || 24) * 3600000) return null;
        if ((cfg.excluded || []).indexOf(String(v.handle).toLowerCase()) !== -1) return null;
        return v;
      } catch (e) { return null; }
    }

    function loadCollection(handle) {
      var url = rootPath() + 'collections/' + encodeURIComponent(handle) + '?view=' + cfg.viewName;
      if (cfg.sort && cfg.sort !== 'manual') url += '&sort_by=' + encodeURIComponent(cfg.sort);
      return fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (text) {
          var data = JSON.parse(text);
          if (!data || !data.products || !data.products.length) throw new Error('empty');
          feed = data;
        })
        .catch(function () { /* keep the server seed */ })
        .then(function () { rebuild(); });
    }

    /* ------------------------------------------------------------ ranking */

    function rebuild() {
      if (!feed || !feed.products || !feed.products.length) { qaEl.hidden = true; return; }

      byId = {};
      feed.products.forEach(function (p) { byId[p.id] = p; });
      computeTitlePrefix();

      var inCart = (cartState.productIds || []).map(String);
      var cartTags = {};
      (cartState.tags || []).forEach(function (t) { if (t) cartTags[String(t).toLowerCase()] = true; });

      pool = feed.products.filter(function (p) {
        if (!p || !p.id) return false;
        if (cfg.hideInCart && inCart.indexOf(String(p.id)) !== -1) return false;
        return (p.variants || []).some(function (v) { return v.available; });
      });

      // Tag overlap is a stable tie-break on top of the sort, so best selling survives.
      if (cfg.tagMatching) {
        pool = pool
          .map(function (p, i) {
            var score = (p.tags || []).reduce(function (n, t) {
              return n + (cartTags[String(t).toLowerCase()] ? 1 : 0);
            }, 0);
            return { p: p, score: score, i: i };
          })
          .sort(function (a, b) { return b.score - a.score || a.i - b.i; })
          .map(function (x) { return x.p; });
      }

      shown = pool.slice(0, cfg.limit || 12).map(function (p) { return p.id; });
      paint();
    }

    /* ------------------------------------------------------------- render */

    function prefillQty() {
      if (!cfg.prefillQty) return 1;
      if (!cartState.hasNext || !cartState.needed || cartState.needed < 1) return 1;
      return Math.max(1, Math.min(cartState.needed, cfg.maxPrefill || 12));
    }

    function hintText() {
      if (!cartState.hasNext) return 'Best price reached';
      return String(S.hint || '')
        .replace('[qty]', cartState.needed)
        .replace('[reward]', cartState.nextReward)
        .replace('[percent]% off', cartState.nextReward)
        .replace('[percent]%', cartState.nextRewardShort)
        .replace('[percent]', cartState.nextPct);
    }

    // Strip the collection title from the front of a product name. Company store
    // titles all start with the company name, which tells the shopper nothing
    // and eats the whole tile.
    // The prefix worth trimming is whichever is longer: the collection title, or
    // the run of characters every product in the feed shares. Company store
    // collections need the first ("Aliso Ridge Behavioral Health Wick Fleece").
    // Catalog collections need the second: every product is "Merchloop - ..." in a
    // collection called "T Shirts - ML", where a title match finds nothing at all.
    var titlePrefix = '';

    function computeTitlePrefix() {
      titlePrefix = '';
      if (!cfg.trimTitles || !feed) return;

      var candidates = [];

      if (feed.title) {
        var words = String(feed.title).split(/\s+/);
        for (var n = words.length; n >= 2; n--) candidates.push(words.slice(0, n).join(' '));
      }

      var titles = (feed.products || []).map(function (p) { return String(p.title || ''); })
        .filter(function (t) { return t.length; });

      if (titles.length > 1) {
        var k = 0;
        while (k < titles[0].length) {
          var ch = titles[0].charAt(k), same = true;
          for (var i = 1; i < titles.length; i++) {
            if (titles[i].charAt(k) !== ch) { same = false; break; }
          }
          if (!same) break;
          k++;
        }
        // Back off to a word or separator boundary so a name is never cut mid-word.
        var m = titles[0].slice(0, k).match(/^(.*[\s\-–—:|])[^\s\-–—:|]*$/);
        if (m && m[1]) candidates.push(m[1]);
      }

      // Longest candidate that still leaves every title with something to show.
      candidates.sort(function (a, b) { return b.length - a.length; });
      for (var c = 0; c < candidates.length; c++) {
        var pre = candidates[c], ok = titles.length > 0;
        for (var t = 0; t < titles.length; t++) {
          if (titles[t].toLowerCase().indexOf(pre.toLowerCase()) !== 0) { ok = false; break; }
          if (!titles[t].slice(pre.length).replace(/^[\s\-–—:,|]+/, '')) { ok = false; break; }
        }
        if (ok) { titlePrefix = pre; return; }
      }
    }

    function shortTitle(t) {
      if (!titlePrefix) return t;
      var out = String(t);
      if (out.toLowerCase().indexOf(titlePrefix.toLowerCase()) !== 0) return out;
      return out.slice(titlePrefix.length).replace(/^[\s\-–—:,|]+/, '') || out;
    }

    // One CDN URL serves both the swatch card and the gallery. Shopify honours a
    // width parameter, so small renders fetch a small file instead of making the
    // browser downscale a 700px image ten times over on a cart page.
    function atWidth(url, w) {
      return String(url).replace(/([?&]width=)\d+/, '$1' + w);
    }

    function colorImage(p, value) {
      return (p.swatch1 && p.swatch1[value]) || null;
    }

    function colorOption(p) {
      var opts = p.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (COLOR_OPTS.indexOf(String(opts[i].name).toLowerCase()) !== -1) {
          return { opt: opts[i], index: i };
        }
      }
      return null;
    }


    function swatchFor(value) {
      var v = String(value).toLowerCase().trim();
      if (SW[v]) return SW[v];
      var keys = Object.keys(SW), best = null;
      for (var i = 0; i < keys.length; i++) {
        if (v.indexOf(keys[i]) !== -1 && (!best || keys[i].length > best.length)) best = keys[i];
      }
      return best ? SW[best] : null;
    }

    // Reads as text rather than as dots. An 11px crop of a garment photo is mud,
    // and these shade names cannot be mapped to flat colours anyway.
    function colorCountHTML(p) {
      var found = colorOption(p);
      if (!found || !found.opt.values || found.opt.values.length < 2) return '';
      var n = found.opt.values.length;
      return '<span class="cu-sep">&middot;</span><span>' + n + ' ' + (n === 1 ? 'color' : 'colors') + '</span>';
    }

    function priceBlock(p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      var lo = avail.length ? avail[0] : (p.variants || [])[0];
      var varies = false;
      for (var i = 1; i < avail.length; i++) { if (avail[i].price !== avail[0].price) { varies = true; break; } }
      var min = lo;
      avail.forEach(function (v) { if (v.price < min.price) min = v; });
      return '<div class="cu-tmeta"><b>' + (varies ? '<span>' + esc(S.from) + ' </span>' : '') +
        esc(min ? min.price_formatted : p.price_formatted) +
        (!varies && p.compare_at_formatted ? '<s>' + esc(p.compare_at_formatted) + '</s>' : '') + '</b>' +
        colorCountHTML(p) + '</div>';
    }

    // Same wording the theme puts on its own product cards: a product with
    // options says so, a single-variant product offers the cart directly.
    function tileCTA(p) {
      var many = (p.variants || []).length > 1;
      return (many && S.choose) ? S.choose : S.add;
    }

    function tileHTML(p) {
      return '<div class="cu-tile" data-cu-tile data-product="' + esc(p.id) + '">' +
        '<a class="cu-thumb" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="500" height="500">' : '') +
        '</a>' +
        '<a class="cu-name" href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(shortTitle(p.title)) + '</a>' +
        priceBlock(p) +
        '<div class="cu-tfoot">' +
          '<button type="button" class="cu-btn cu-btn--ghost" data-cu-open>' + esc(tileCTA(p)) + '</button>' +
        '</div>' +
        (cfg.showHints ? '<div class="cu-hint" data-cu-hint>' + esc(hintText()) + '</div>' : '') +
      '</div>';
    }

    function paint() {
      if (!shown.length) { qaEl.hidden = true; return; }
      trackEl.innerHTML = shown.map(function (id) { return tileHTML(byId[id]); }).join('');
      qaEl.hidden = false;

      if (titleEl && S.headingStore && feed && feed.title) {
        titleEl.textContent = S.headingStore.replace('[collection]', feed.title);
      }
      if (linkEl && feed && feed.url) { linkEl.href = feed.url; linkEl.hidden = false; }
      updateNav();
    }

    function skeleton(n) {
      var out = '';
      for (var i = 0; i < n; i++) out += '<div class="cu-skel"></div>';
      trackEl.innerHTML = out;
      qaEl.hidden = false;
    }

    /* --------------------------------------------------------- drawer */

    function productFor(id) { return byId[id] || { variants: [], options: [] }; }

    function isAvailable(p, trial) {
      return (p.variants || []).some(function (v) {
        return v.available && trial.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function matched(p) {
      var vals = (p.options || []).map(function (o, i) { return sel[i] == null ? null : sel[i]; });
      if (!vals.length || vals.indexOf(null) !== -1) return null;
      return (p.variants || []).filter(function (v) {
        return vals.every(function (val, i) { return v.options[i] === val; });
      })[0] || null;
    }

    function openDrawer(id) {
      openId = id;
      var p = productFor(id);
      sel = {};
      (p.options || []).forEach(function (o, i) { if ((o.values || []).length === 1) sel[i] = o.values[0]; });

      // Open on the first colour rather than on an empty picker, so the panel
      // shows a garment straight away and the chip row starts somewhere.
      // First colour that actually has stock, because opening on a sold-out
      // shade would strike through every size below it. Falls back to the first
      // listed colour if none of them are available at all.
      var opened = colorOption(p);
      if (opened && sel[opened.index] == null) {
        var vals = opened.opt.values || [];
        var pick = null;
        for (var vi = 0; vi < vals.length; vi++) {
          var val = vals[vi];
          var trial = (p.options || []).map(function (x, k) { return k === opened.index ? val : null; });
          if (isAvailable(p, trial)) { pick = val; break; }
        }
        if (pick == null) pick = vals[0];
        if (pick != null) sel[opened.index] = pick;
      }

      var qtyInput = panelEl.querySelector('[data-cu-qty]');
      if (qtyInput) {
        qtyInput.value = prefillQty();
        delete qtyInput.dataset.cuDirty;
      }

      // Unhide first: the panel is still translated off-screen, so nothing
      // flashes, but the gallery can now be measured for its scroll rail.
      scrimEl.hidden = false;
      panelEl.hidden = false;
      jumpToTop = true;
      paintPanel();
      // Next frame, so the transition runs from the off-screen position rather
      // than snapping straight to open.
      requestAnimationFrame(function () {
        scrimEl.classList.add('is-open');
        panelEl.classList.add('is-open');
      });
      panelEl.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      Array.prototype.forEach.call(root.querySelectorAll('[data-cu-tile]'), function (t) {
        t.classList.toggle('is-active', t.dataset.product === String(id));
      });

      var close = panelEl.querySelector('[data-cu-close]');
      if (close) setTimeout(function () { close.focus(); }, 340);
    }

    function closeDrawer() {
      if (openId === null) return;
      openId = null;
      panelEl.classList.remove('is-open');
      scrimEl.classList.remove('is-open');
      panelEl.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-cu-tile]'), function (t) {
        t.classList.remove('is-active');
      });
      // Hide only once the slide-out has finished, so it animates rather than
      // vanishing, but never leave it interactive if the event does not fire.
      setTimeout(function () {
        if (openId !== null) return;
        panelEl.hidden = true;
        scrimEl.hidden = true;
      }, 340);
    }

    function isColorOptionName(name) {
      return COLOR_OPTS.indexOf(String(name).toLowerCase()) !== -1;
    }

    function optionHTML(p, o, i) {
      var values = o.values || [];
      var useSwatches = cfg.showSwatches && isColorOptionName(o.name);
      var body = '';

      values.forEach(function (val) {
        var trial = (p.options || []).map(function (x, k) { return k === i ? val : (sel[k] == null ? null : sel[k]); });
        var off = !isAvailable(p, trial);
        var pressed = sel[i] === val;

        if (useSwatches) {
          // Photo and name together. The photo alone will not tell a shopper this
          // shade is called CRUNCHBERRY, and the name alone will not tell them
          // what it looks like, so the swatch has to carry both.
          var img = colorImage(p, val);
          var face = img
            ? '<img src="' + esc(atWidth(img, 160)) + '" alt="" loading="lazy">'
            : '<span class="cu-swflat" style="background-color:' + esc(swatchFor(val) || '#bbbbbb') + '"></span>';
          // The chosen colour is named beside the option label, so the chip itself
          // only has to show the garment.
          body += '<button type="button" class="cu-swchip' + (off ? ' is-off' : '') + '"' +
            ' data-cu-opt="' + i + '" data-cu-val="' + esc(val) + '"' +
            ' aria-pressed="' + pressed + '" title="' + esc(val) + '"' +
            ' aria-label="' + esc(val) + '">' + face + '</button>';
        } else {
          body += '<button type="button" class="cu-chip' + (off ? ' is-off' : '') + '"' +
            ' data-cu-opt="' + i + '" data-cu-val="' + esc(val) + '"' +
            ' aria-pressed="' + pressed + '">' + esc(val) + '</button>';
        }
      });

      var chosen = sel[i] != null ? '<em class="cu-osel">' + esc(sel[i]) + '</em>' : '';

      return '<div class="cu-opt">' +
        '<span class="cu-olabel">' + esc(o.name) + chosen + '</span>' +
        '<div class="' + (useSwatches ? 'cu-swchips' : 'cu-chips') + '">' + body + '</div>' +
        '</div>';
    }

    // One image, not a carousel. Each colour here has a single mockup and the
    // product's own media is that same set of mockups, so a scroller just showed
    // the shopper every colourway they did not pick. Chosen colour if there is
    // one, otherwise the featured image.
    function galleryHTML(p) {
      var found = colorOption(p);
      var picked = (found && sel[found.index] != null) ? colorImage(p, sel[found.index]) : null;
      var url = picked || p.image || (p.images && p.images[0]);
      if (!url) return '';

      var badge = (found && sel[found.index] != null)
        ? '<span class="cu-galtag">' + esc(sel[found.index]) + '</span>'
        : '';

      return '<div class="cu-gal">' +
        '<img class="cu-galimg" src="' + esc(atWidth(url, 700)) + '" alt="" loading="lazy">' +
        badge +
      '</div>';
    }


    // Price shown in the panel: the resolved variant once options are chosen,
    // otherwise the cheapest available, prefixed with "From" when they differ.
    function panelPrice(p, v) {
      if (v) return esc(v.price_formatted);
      var avail = (p.variants || []).filter(function (x) { return x.available; });
      if (!avail.length) return esc(p.price_formatted);
      var min = avail[0], varies = false;
      avail.forEach(function (x) {
        if (x.price < min.price) min = x;
        if (x.price !== avail[0].price) varies = true;
      });
      return (varies ? '<span>' + esc(S.from) + ' </span>' : '') + esc(min.price_formatted);
    }

    // Choosing a size repaints the body, which would otherwise throw the shopper
    // back to the top of the panel. Choosing a colour SHOULD go back to the top,
    // because that is where the new preview is.
    var jumpToTop = true;

    function paintPanel() {
      var keepScroll = jumpToTop ? 0 : pbodyEl.scrollTop;
      var p = productFor(openId);
      var v = matched(p);
      var ready = !!(v && v.available);
      var opts = '';

      (p.options || []).forEach(function (o, i) {
        if ((o.values || []).length < 2) return;
        opts += optionHTML(p, o, i);
      });

      pbodyEl.innerHTML =
        galleryHTML(p) +
        '<div class="cu-pmain">' +
          '<h3 class="cu-pname">' + esc(shortTitle(p.title)) + '</h3>' +
          '<p class="cu-pprice">' + panelPrice(p, v) +
            (p.compare_at_formatted ? '<s>' + esc(p.compare_at_formatted) + '</s>' : '') + '</p>' +
          '<a class="cu-pdetails" href="' + esc(p.url) + '">' + esc(S.details) + '</a>' +
          '<div class="cu-opts">' + opts + '</div>' +
        '</div>';

      var qtyInput = panelEl.querySelector('[data-cu-qty]');
      var n = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var btn = panelEl.querySelector('[data-cu-add]');
      if (btn) {
        btn.disabled = !ready;
        btn.classList.remove('is-done');
        if (ready) {
          btn.dataset.variant = v.id;
          btn.textContent = S.add;
        } else {
          delete btn.dataset.variant;
          btn.textContent = (v && !v.available) ? S.soldOut : 'Select options';
        }
      }

      // Carry the tier maths into the panel, so the shopper is not left doing
      // arithmetic against a bar they can no longer see.
      if (ptierEl) {
        if (cartState.hasNext) {
          var after = cartState.itemCount + n;
          var left = Math.max(0, cartState.needed - n);
          ptierEl.textContent = left > 0
            ? ('Adding ' + n + ' takes you to ' + after + ' pieces, ' + left + ' short of ' + cartState.nextReward + '.')
            : ('Adding ' + n + ' takes you to ' + after + ' pieces and unlocks ' + cartState.nextReward + '.');
        } else {
          ptierEl.textContent = '';
        }
      }

      pbodyEl.scrollTop = keepScroll;
      jumpToTop = false;
    }

    /* -------------------------------------------------------- section swap */

    function themeSectionIds() {
      var ids = [];
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items && items.dataset.id) ids.push(items.dataset.id);
      if (footer && footer.dataset.id) ids.push(footer.dataset.id);
      ids.push('cart-icon-bubble', 'cart-icon-bubble--mobile');
      return ids.slice(0, 5);
    }

    function swapSection(sections, hostId, selector, key) {
      var html = sections && sections[key];
      var host = document.getElementById(hostId);
      if (!html || !host) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      var dest = host.querySelector(selector) || host;
      if (src) dest.innerHTML = src.innerHTML;
    }

    function applyThemeSections(sections) {
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items) swapSection(sections, 'main-cart-items', '.js-contents', items.dataset.id);
      if (footer) swapSection(sections, 'main-cart-footer', '.js-contents', footer.dataset.id);
      swapSection(sections, 'cart-icon-bubble', '.shopify-section', 'cart-icon-bubble');
      swapSection(sections, 'cart-icon-bubble--mobile', '.shopify-section', 'cart-icon-bubble--mobile');
    }

    /* ------------------------------------------------------------ add flow */

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || S.error;
      errEl.hidden = false;
      setTimeout(function () { errEl.hidden = true; }, 6000);
    }

    function retire(id) {
      if (!cfg.hideInCart) return;
      var next = pool.filter(function (p) {
        return shown.indexOf(p.id) === -1 && String(p.id) !== String(id);
      })[0];
      shown = shown.filter(function (s) { return String(s) !== String(id); });
      if (next) shown.push(next.id);
      if (!shown.length) { qaEl.hidden = true; return; }
      paint();
    }

    function addToCart(variantId, quantity, btn, id) {
      if (busy || !variantId) return;
      busy = true;
      var label = btn.textContent;
      btn.classList.add('is-busy');
      btn.textContent = 'Adding';

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
          sections: themeSectionIds(),
          sections_url: rootPath() + 'cart'
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || '');
          applyThemeSections(res.data.sections);
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          btn.textContent = S.added;
          setTimeout(function () {
            if (openId !== null && String(openId) === String(id)) closeDrawer();
            retire(id);
          }, 1000);
        })
        .catch(function (e) {
          btn.classList.remove('is-busy');
          btn.textContent = label;
          showError(e && e.message ? e.message : null);
        })
        .then(function () { busy = false; });
    }

    /* ----------------------------------------------------------- refreshes */

    function refreshProgress() {
      return fetch(rootPath() + 'cart?sections=' + encodeURIComponent(cfg.sectionId))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[cfg.sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cu-progress]');
          var current = root.querySelector('[data-cu-progress]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            current.className = fresh.className;
          }

          cartState = readCartState();
          root.hidden = cartState.itemCount === 0;

          var q = prefillQty(), h = hintText();
          Array.prototype.forEach.call(root.querySelectorAll('[data-cu-qty]'), function (input) {
            if (input.dataset.cuDirty !== '1') input.value = q;
          });
          Array.prototype.forEach.call(root.querySelectorAll('[data-cu-hint]'), function (el) {
            el.textContent = h;
          });
        })
        .catch(function () {});
    }

    /* -------------------------------------------------------------- events */

    function updateNav() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = trackEl.scrollLeft < 4;
      nextBtn.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 4;
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Top up: prime every stepper to the exact gap, ignoring the pre-fill cap,
      // then bring the slider into view. Nothing is added without a product choice.
      var top = t.closest('[data-cu-topup]');
      if (top) {
        var need = parseInt(top.dataset.need, 10) || 1;
        Array.prototype.forEach.call(root.querySelectorAll('[data-cu-qty]'), function (input) {
          input.value = need;
          input.dataset.cuDirty = '1';
          var box = input.parentNode;
          box.classList.remove('is-primed');
          void box.offsetWidth;
          box.classList.add('is-primed');
        });
        if (!qaEl.hidden) {
          trackEl.scrollTo({ left: 0 });
          qaEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }

      var step = t.closest('[data-cu-step]');
      if (step) {
        var inp = step.parentNode.querySelector('[data-cu-qty]');
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(step.dataset.cuStep, 10));
        inp.dataset.cuDirty = '1';
        if (openId !== null) paintPanel();
        return;
      }

      var open = t.closest('[data-cu-open]');
      if (open) {
        openDrawer(open.closest('[data-cu-tile]').dataset.product);
        return;
      }

      if (t === scrimEl) { closeDrawer(); return; }


      if (t.closest('[data-cu-close]')) { closeDrawer(); return; }

      var chip = t.closest('[data-cu-opt]');
      if (chip) {
        if (chip.classList.contains('is-off')) return;
        var oi = parseInt(chip.dataset.cuOpt, 10);
        sel[oi] = chip.dataset.cuVal;
        var picked = colorOption(productFor(openId));
        jumpToTop = !!(picked && picked.index === oi);
        paintPanel();
        return;
      }

      if (t.closest('[data-cu-prev]')) { trackEl.scrollBy({ left: -trackEl.clientWidth * 0.8 }); return; }
      if (t.closest('[data-cu-next]')) { trackEl.scrollBy({ left: trackEl.clientWidth * 0.8 }); return; }

      var add = t.closest('[data-cu-add]');
      if (add && !add.disabled) {
        var qtyInput = panelEl.querySelector('[data-cu-qty]');
        addToCart(add.dataset.variant, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, add, openId);
      }
    });

    root.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-cu-qty]')) e.target.dataset.cuDirty = '1';
    });

    trackEl.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);

    document.addEventListener('keydown', function (e) {
      if (openId !== null && (e.key === 'Escape' || e.key === 'Esc')) closeDrawer();
    });

    // Keep tab focus inside the panel while it is modal.
    panelEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || openId === null) return;
      var f = panelEl.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Any cart mutation on the page, including Minion's own steppers and remove
    // buttons, re-renders the ladder.
    if (!window.__cartUpsellFetchPatched) {
      window.__cartUpsellFetchPatched = true;
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var url = '';
        try {
          url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
        } catch (e) {}
        return nativeFetch.apply(this, arguments).then(function (res) {
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            document.dispatchEvent(new CustomEvent('cart-upsell:changed'));
          }
          return res;
        });
      };
    }

    var pending = null;
    document.addEventListener('cart-upsell:changed', function () {
      clearTimeout(pending);
      pending = setTimeout(refreshProgress, 450);
    });

    /* ---------------------------------------------------------------- boot */

    var last = lastCollection();
    var target = (last && last.handle) || (feed && feed.handle) || '';
    var seedMatches = feed && feed.handle && target === feed.handle;

    if (seedMatches) rebuild(); else if (target) skeleton(cfg.limit || 12);

    if (target && (!seedMatches || (cfg.sort && cfg.sort !== 'manual'))) {
      loadCollection(target);
    } else if (!target) {
      qaEl.hidden = true;
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-cart-upsell]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
